import useStyles from './styles'
import {Card,CardMedia} from '@material-ui/core'
const Modal = (props)=>{
    const classes = useStyles();
    return (
        <div>
            <div className={classes.backdrop} onClick={props.onCancel}/>
            <Card raised className={classes.card}>
						<CardMedia className={classes.cardMedia} image={props.image} title="image title"/>

			</Card>
        </div>
    )
}
export default Modal;